import { type TFunction } from 'i18next';

/** "7 Days", "3 Mo." — VIP periods of whole months are shown in months. */
const vipPeriodLabel = (days: number, t: TFunction): string =>
  days % 30 === 0 ? `${days / 30} ${t('Mo.')}` : `${days} ${t('Days')}`;

/** Renewal period of a VIP subscription: "every week", "every 3 months". */
const vipRenewalPeriod = (days: number, t: TFunction): string => {
  switch (days) {
    case 7:
      return t('every week');
    case 90:
      return t('every 3 months');
    case 180:
      return t('every 6 months');
    default:
      return t('every month');
  }
};

export { vipPeriodLabel, vipRenewalPeriod };
